class UpsellV2 extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('recommendation-product-id');
    this.recommendationType = this.getAttribute('recommendation-type');
    this.recommendationSectionName = this.getAttribute('recommendation-section');
    this.recommendationLimit = this.getAttribute('recommendation-limit');
    this.didLoad = false;
    this.elObj = {
      recommendationEl: '[products-data]',
      recommendationTitle: '[title]',
    };
    this.addEventListener('observe:elementInView', () => {
      if (this.didLoad) return;
      this.fetchData();
    });
  }

  queryHTMLData(htmlString, elementToQuery) {
    const html = new DOMParser().parseFromString(htmlString, 'text/html');
    return html.querySelector(elementToQuery).innerHTML;
  }

  renderTitle() {
    const tpl = this.querySelector('template');
    const titleSlot = this.querySelector('[data-upsell-title]');
    if (!tpl || !titleSlot) return;
    const tplTitle = tpl.content.firstElementChild;
    titleSlot.textContent = tplTitle ? tplTitle.textContent.trim() : '';
  }

  showLayout() {
    this.classList.remove('upsell-v2--inactive');
  }

  generateLayouts(textData) {
    const returnedHTML = this.queryHTMLData(textData, this.elObj.recommendationEl);
    if (returnedHTML && returnedHTML.trim()) {
      try {
        const target = this.querySelector(this.elObj.recommendationEl);
        target.innerHTML = returnedHTML;
        this.renderTitle();
        this.showLayout();
        this.enableTrackpadScroll();
      } catch (error) {
        console.log(error);
      }
    }
  }

  enableTrackpadScroll() {
    const tryEnable = (attempt = 0) => {
      const carousel = this.querySelector('carousel-component');
      const swiper = carousel && carousel.swiperInstance;
      if (!swiper) {
        if (attempt < 25) setTimeout(() => tryEnable(attempt + 1), 120);
        return;
      }
      const container = swiper.el || carousel.querySelector('[main-slider]');
      if (!container || container.dataset.wheelBound) return;
      container.dataset.wheelBound = '1';

      let lock = false;
      container.addEventListener(
        'wheel',
        (e) => {
          const absX = Math.abs(e.deltaX);
          const absY = Math.abs(e.deltaY);
          // Only intercept clearly-horizontal trackpad gestures
          if (absX <= absY || absX < 4) return;

          const atStart = swiper.isBeginning && e.deltaX < 0;
          const atEnd = swiper.isEnd && e.deltaX > 0;
          if (atStart || atEnd) return; // let the page scroll at the edges

          e.preventDefault();
          if (lock) return;
          lock = true;
          if (e.deltaX > 0) swiper.slideNext();
          else swiper.slidePrev();
          setTimeout(() => {
            lock = false;
          }, 250);
        },
        { passive: false }
      );
    };
    tryEnable();
  }

  fetchData() {
    this.didLoad = true;
    HELPER_UTIL.fetchData({
      method: 'GET',
      responseType: 'text',
      url: `${window.Shopify.routes.root}recommendations/products?product_id=${this.productId}&limit=${this.recommendationLimit}&section_id=${this.recommendationSectionName}&intent=${this.recommendationType}`,
      onsuccess: (textData) => {
        this.generateLayouts(textData);
      },
      onerror: (error) => {
        console.log(error);
      },
    });
  }
}

customElements.get('upsell-v2') || customElements.define('upsell-v2', UpsellV2);
